// extracted by mini-css-extract-plugin
module.exports = {"links":"_3MmGvF","heading":"LfkXVL","display-text":"_2oyLgr","brand-title":"_2XoPFN","seolink":"_3CuAg8","link-group":"_1GTrm1"};